import { css } from 'linaria';
import { styled } from 'linaria/react';
import { ElementType } from 'react';

export const topLineSeeMoreStyles = css`
  position: relative;
  top: -4px;
  white-space: nowrap;
`;
export const topLineItemStyles = css`
  @media (--from-tablet) {
    &:not(&:last-of-type) {
      margin-right: var(--space-250);
    }
  }
`;
export const controlStyles = css`
  box-shadow: var(--box-shadow-m);
`;
export const iconOnlyControlStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--space-600);
  height: var(--space-600);
  padding: 0;
  border: none;
  border-radius: 50%;
  color: var(--text-primary);
  box-shadow: var(--box-shadow-m);
  cursor: pointer;
`;

export const invertedIconOnlyControlStyles = css`
  background-color: var(--background-primary);
`;
export const sponsoredSeeMoreCardStylesMedia = css`
  @media (--to-tablet) {
    box-sizing: content-box;
    width: 139px !important;
    height: 272px !important;
    padding: 16px;
  }
`;
export const seeMoreCardStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: var(--space-450);
  text-decoration: none;
  width: 100%;
  height: 100%;
`;
export const seeMoreCardSponsoredStyles = css`
  width: 192px;
  background-color: var(--background-primary);
  border-radius: 8px;

  @media (--from-tablet) and (--only-mobile) {
    min-width: auto;
  }
`;
export const SeeMoreCaption: ElementType = styled.span`
  margin-top: var(--space-150) !important;
`;
export const seeMoreCaptionSponsoredStyles = css`
  font-size: 15px !important;
`;
